import { getCurrentFindingMethod } from '@src/telemetry/findingMethod'
import { getProductPropertiesForTracking } from '@src/telemetry/getProductPropertiesForTracking'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import { QUINCE } from '../../constants/app'
import { ProductOptionName } from '../../domains/ProductOption'
import productHelper from '../../helpers/productHelper'
import { TBuyNowCartVariant, TTrackingLineItem } from '../../hooks/cart/types'

export const handleBuyNowTracking = (variantInfos: TBuyNowCartVariant[], lineItems: TTrackingLineItem[]) => {
  variantInfos.forEach(
    ({
      product,
      selectedOptions,
      quantity,
      trackerSection,
      inventoryInfoSource,
      productPosition,
      productSearchQuery,
      isPreorder,
    }) => {
      const variants = productHelper.getVariantsForOptions(product, selectedOptions)
      const currentFindingMethod = getCurrentFindingMethod()
      if (variants.length == 1) {
        const selectedVariant = variants[0]
        const productColor = selectedOptions.filter(t => t.name === ProductOptionName.Color)[0]?.value
        trackEvent(TELEMETRY_EVENT_NAMES.BUY_NOW, {
          variantId: selectedVariant?.svid,
          productId: product.spid,
          internalProductId: `${product.id}_${productColor}`,
          productType: product.productTypeName,
          size: selectedVariant?.options.filter(t => t.name === ProductOptionName.Size)[0]?.value,
          price: selectedVariant?.price,
          vendor: QUINCE,
          productTitle: product.title,
          variantTitle: selectedVariant?.title,
          sku: selectedVariant?.sku,
          quantity: quantity,
          trackerSection,
          isPreorder: Boolean(isPreorder),
          productSearchQuery,
          productPosition,
          inventoryInfoSource,
          division: product.classification?.division?.name,
          department: product.classification?.department?.name,
          subDepartment: product.classification?.subDepartment?.name,
          color_variant: product.new_color_options && (product.new_color_options || []).map(item => item.value),
          gender: product.gender,
          productProperties: getProductPropertiesForTracking(product, selectedVariant?.svid?.toString()),
          lineItems,
          context: {
            findingMethodAggregate: currentFindingMethod?.findingMethodAggregate,
            findingMethodGranular: currentFindingMethod?.findingMethodGranular,
            findingMethodId: currentFindingMethod?.findingMethodId,
          },
        })
      }
    },
  )
}
